import { formatDateToMMDDYY, formatPriceWithCommas, stripCustPrefix } from '../../../../../utils/CommonFunctions';
import { OilKitsResponseData, OilKitsData } from './TypeOilKits';

export function formatTableData(data: OilKitsResponseData[]) {
  const res: OilKitsData[] = [];

  data.forEach((col: OilKitsResponseData, index) => {
    const obj = {
      sn: index,
      action: 'edit&delete&invoice',
      KitId: '',
      CustId: '',
      CustomerName: '',
      PurchaseOrderNumber: '',
      shipDate: '',
      BillAmount: '',
      billed: false,
      createdBy: '',
      id: '',
      isChecked: false,
    };

    obj.KitId = col.KitId;
    obj.id = col.KitId;
    obj.CustId = stripCustPrefix(col.CustId);
    obj.CustomerName = col.CustomerName;
    obj.PurchaseOrderNumber = col.PurchaseOrderNumber;
    obj.shipDate = formatDateToMMDDYY(col.ShipDate);
    obj.BillAmount = `$ ${formatPriceWithCommas(String(col.BillAmount))}`;
    obj.billed = col.Billed;
    obj.createdBy = col.CreatedBy;
    res.push(obj);
  });

  return res;
}
